import { createContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { ProfileProvider } from '../context';
import { useAuth } from '../hooks';

// Create a context for the user
export const AuthUserContext = createContext(null);

const openPaths = [ '/login', '/signup', '/' ];

export function AuthComponent({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  const currentPath = location.pathname;
  const { loading, user, setUser } = useAuth();

  console.log('currentPath', currentPath, user, loading);

  useEffect(() => {
    if (loading) return;

    if (!user) {
      if (openPaths.includes(currentPath)) {
        return;
      }

      return navigate('/login');
    }

    if (user) {
      setUser(user);

      if (openPaths.includes(currentPath)) {
        return navigate('/home');
      }

      navigate({ 
        pathname: currentPath, 
        search: location.search 
      }, { replace: true });
    }
  }, [ currentPath, loading, location.search, navigate, setUser, user ]);

  if (loading) {
    // TODO: loading spinner
    return <div>loading user...</div>;
  }

  // TODO: move user context to own file
  return (
    <AuthUserContext.Provider value={{ user, setUser }}>
      <ProfileProvider>{children}</ProfileProvider>
    </AuthUserContext.Provider>
  );
}
